import Text from '../text/component';
export default Text;
